// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import classnames from "classnames";
import { PrivateRoute } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
import selectors from "model/selectors";
import { LOCK_KEYS } from "accessConfig";

import Page from "../Page";
import Data from "../Data";
// import Search from "containers/workflow-client/pages/Search";
// import Emission from "containers/workflow-client/pages/Emission";
// import Acquiring from "containers/workflow-client/pages/Acquiring";

// RELATIVE PATH IMPORTS

// connecting component to the redux store
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      canViewProcessingWorkflow: selectors.access.getLockState(
        state,
        LOCK_KEYS.PROCESSING_WORKFLOW_ACCESS
      ),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("processing-workflow")
export default class ProcessingWorkflow extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    match: PropTypes.object,
    canViewProcessingWorkflow: PropTypes.bool,
    sessionStatusConfirmed: PropTypes.bool,
    requestInProgress: PropTypes.bool,
  };

  render() {
    const { theme, match, canViewProcessingWorkflow } = this.props;
    return (
      <div className={classnames(theme.app)}>
        <Switch>
          <PrivateRoute
            auth={canViewProcessingWorkflow}
            path={`${match.path}/:subdir`}
            render={() => (
              <Page basePath={match.path} pageHeader={"Процессинг"}>
                <Data basePath={match.path} />
              </Page>
            )}
          />
          <PrivateRoute
            auth={canViewProcessingWorkflow}
            path="*"
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Workflow/Workflow.js